export default __webpack_public_path__ + "static/media/text.4c9bf04b.svg";